// extracted by mini-css-extract-plugin
export var buttonContent = "_40-0";
export var conversationsCardFooter = "_40-1";
export var conversationsCardHeader = "_40-2";
export var icon = "_40-3";